import React from 'react';
import { ProtectedPermissionRoute } from '@nimbitlabs/auth';
import { Settings } from './Settings';

export const settingsRoutes = [
  { 
    path: '/settings', 
    element: <ProtectedPermissionRoute element={<Settings />} permission="settings:read" />, 
    permission: 'settings:read' 
  },
];
